/**
 * CSRF Token Management for Cross-Origin Cookie Authentication
 * 
 * Only needed when CROSS_ORIGIN=true on server (sameSite='none')
 * When sameSite='strict' (default), this is not needed
 */

/**
 * Get CSRF token from cookie
 * @returns {string|null} CSRF token or null
 */
export function getCSRFToken(): string | null {
  const cookies = document.cookie.split('; ');
  
  // Check both production and development cookie names
  const csrfCookie = cookies.find(row => 
    row.startsWith('csrf=') || row.startsWith('__Host-csrf=')
  );
  
  if (!csrfCookie) {
    return null;
  }
  
  const token = csrfCookie.split('=')[1];
  return token || null;
}

/**
 * Setup CSRF token interceptor for axios
 * Call this once during app initialization
 */
export function setupCSRFInterceptor(httpClient: any) {
  httpClient.interceptors.request.use((config: any) => {
    // Get CSRF token from cookie
    const csrfToken = getCSRFToken();
    
    // Add to header if token exists
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken;
    }
    
    return config;
  });
}

/**
 * Check if CSRF protection is active
 * @returns {boolean} True if CSRF token cookie exists
 */
export function isCSRFActive(): boolean {
  return getCSRFToken() !== null;
}

